import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Loading } from "../../../../shared/components";
import getAllSubscriptionDashboard from "../../../proposals/services/subscription.service";
import ListTable from "../../../../shared/components/lists/list-table/list-table";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../../../context";
import { getDateByUTC } from "../../../../shared/utils/string.utils";
import DashboardError from "../dashboard-error/dashboard-error";

const DashboardSubscription = () => {
    const { t } = useTranslation();
    const [dashboardInfo, setDashboardInfo] = useState();
    const { isAuthenticated, user } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const history = useHistory();
    const redirectSubscription = (row) => {
        const { statusLabel } = row;
        history.push(`/subscriptions/list?limit=50&status=${statusLabel}`);
    }
    const columns = [
        { name: "status", type: "text-button", dbRef: "status", label: t("users:dashbord-proposal.status"), onClick: (row) => { redirectSubscription(row); } },
        { name: "number", type: "text-button", dbRef: "number", label: t("users:dashbord-proposal.number"), onClick: (row) => { redirectSubscription(row); } },
        { name: "value", type: "text-button", dbRef: "value", label: t("users:dashbord-proposal.value"), onClick: (row) => { redirectSubscription(row); } }
    ];
    useEffect(() => {
        if (isAuthenticated && user) {
            setLoading(true);
            getAllSubscriptionDashboard()
                .then((res) => {
                    setDashboardInfo(res.data);
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false);
                });
        }
    }, [isAuthenticated, user]);

    if (loading) return <Loading />;
    const contentRows = [{
        number: dashboardInfo.selled.nb.toLocaleString(),
        value: dashboardInfo.selled.total.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        status: t("users:dashbord-subscription.selled"),
        statusLabel: "Vendu"
    }, {
        number: dashboardInfo.activated.nb.toLocaleString(),
        value: dashboardInfo.activated.total.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        status: t("users:dashbord-subscription.activated"),
        statusLabel: "Activé"
    },
    {
        number: dashboardInfo.suspended.nb.toLocaleString(),
        value: dashboardInfo.suspended.total.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        status: t("users:dashbord-subscription.suspended"),
        statusLabel: "Suspendu"
    },
    {
        number: dashboardInfo.terminated.nb.toLocaleString(),
        value: dashboardInfo.terminated.total.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        status: t("users:dashbord-subscription.terminated"),
        statusLabel: "Abandonné%20%2F%20résilié"
    }];
    return (
        <div className="dashboard">
            <div className="borderdash">
                <div className="total__header dashbord_header">
                    <p>
                        <strong>{t("users:dashbord-subscription.title", { totalSouscriptions: dashboardInfo ? dashboardInfo.nb.toLocaleString() : "" })}</strong>
                    </p>
                    <div className="margin__total">

                        {dashboardInfo && (<>{`${t("users:dashbord-subscription.total")}`} <span className="total-title">{`${dashboardInfo.total.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</span></>) }
                    </div>
                </div>
                {dashboardInfo ? (<ListTable columns={[...columns]} content={contentRows} rowKey="status" />) : (<DashboardError />)}
                <div className="dashboard__lastUpdate">{`${t("users:last-update")}: ${getDateByUTC(dashboardInfo.lastUpdate)}`}</div>
             </div>
        </div>
    );
};

export default DashboardSubscription;
